"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapTryCatchFinallyPromisable = exports.DefaultHookPriority = void 0;
exports.DefaultHookPriority = 0;
function wrapTryCatchFinallyPromisable(func, getHooks, onHookError) {
    function forEachHook(hooks, inContext, doThis) {
        const prioritizedHooks = Object.values(hooks).sort((h1, h2) => {
            const p1 = h1.getPriority ? h1.getPriority(inContext) : exports.DefaultHookPriority;
            const p2 = h2.getPriority ? h2.getPriority(inContext) : exports.DefaultHookPriority;
            return (p1 === undefined ? exports.DefaultHookPriority : p1) - (p2 === undefined ? exports.DefaultHookPriority : p2);
        });
        const postCallbacks = [];
        for (const hook of prioritizedHooks) {
            try {
                const callback = doThis(hook);
                if (callback instanceof Function)
                    postCallbacks.push(callback);
            }
            catch (hookError) {
                let errorToThrow = hookError;
                if (onHookError)
                    errorToThrow = onHookError(errorToThrow);
                if (errorToThrow)
                    throw errorToThrow;
            }
        }
        for (const callback of postCallbacks.reverse()) {
            try {
                callback();
            }
            catch (callbackError) {
                let errorToThrow = callbackError;
                if (onHookError)
                    errorToThrow = onHookError(errorToThrow);
                if (errorToThrow)
                    throw errorToThrow;
            }
        }
    }
    return function (...funcArgs) {
        const ctx = {
            funcArgs: funcArgs,
            funcThis: this,
            func,
            stage: 'try'
        };
        let isPromise = false;
        const hooks = getHooks(ctx);
        try {
            forEachHook(hooks, ctx, (hook) => hook.onTry?.(ctx));
            const funcResMayBePromise = func.apply(this, funcArgs);
            isPromise = isValuePromise(funcResMayBePromise);
            if (isPromise) {
                const wrappedPromise = (async () => {
                    try {
                        ctx.result = await funcResMayBePromise;
                        ctx.stage = 'success';
                        forEachHook(hooks, ctx, (hook) => hook.onSuccess?.(ctx));
                    }
                    catch (error) {
                        ctx.stage = 'catch';
                        ctx.error = error;
                        forEachHook(hooks, ctx, (hook) => hook.onCatch?.(ctx));
                        if (ctx.error)
                            throw ctx.error;
                    }
                    finally {
                        ctx.stage = 'finally';
                        forEachHook(hooks, ctx, (hook) => hook.onFinally?.(ctx));
                    }
                    return ctx.result;
                })();
                return wrappedPromise;
            }
            ctx.result = funcResMayBePromise;
            ctx.stage = 'success';
            forEachHook(hooks, ctx, (hook) => hook.onSuccess?.(ctx));
        }
        catch (error) {
            ctx.stage = 'catch';
            ctx.error = error;
            forEachHook(hooks, ctx, (hook) => hook.onCatch?.(ctx));
            if (ctx.error)
                throw ctx.error;
        }
        finally {
            if (!isPromise) {
                ctx.stage = 'finally';
                forEachHook(hooks, ctx, (hook) => hook.onFinally?.(ctx));
            }
        }
        return ctx.result;
    };
}
exports.wrapTryCatchFinallyPromisable = wrapTryCatchFinallyPromisable;
function isValuePromise(obj) {
    return obj instanceof Object && 'then' in obj && typeof obj.then === 'function';
}
//# sourceMappingURL=wrapTryCatchFinallyPromisable.js.map